module.exports = __webpack_public_path__ + "static/img/logo43.7a15e54.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo43.png
// module id = 39E3
// module chunks = 1